import dayjs from 'dayjs'
import { toCustomTz } from '../toCustomTz'

export const handleCheckDisabledDates = (centreHolidays, date) => {
  let formatCentreHolidays = centreHolidays.map((holiday) => toCustomTz(holiday, 'utc', false, 'YYYY-MM-DD'))
  return formatCentreHolidays.includes(dayjs(date).format('YYYY-MM-DD'))
}
